<h1 mat-dialog-title>Approve Transaction</h1>

<div mat-dialog-content>
    <p>{{ otpData.title }}</p>

    <form [formGroup]="authenticationForm">

        <div class="approvalFormContent">
            <div *ngIf="showUserFields">
                <mat-form-field>
                    <mat-label>Username</mat-label>
                    <input matInput formControlName="username" type="username">
                    <mat-error *ngIf="authenticationForm.controls.username.hasError('required')">
                        Username <strong>is required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="password" type="password">
                    <mat-error *ngIf="authenticationForm.controls.username.hasError('required')">
                        Password <strong>is required</strong>
                    </mat-error>
                    <mat-error *ngIf="authenticationForm.controls.password.hasError('minlength')">
                        Password should be at least <strong>8 characters long</strong>
                    </mat-error>
                    <mat-error *ngIf="authenticationForm.controls.password.hasError('maxlength')">
                        Password should not be more than <strong>50 characters long</strong>
                    </mat-error>
                </mat-form-field>
            </div>
       
            <div *ngIf="showTokenMethodFields">
                <mat-form-field style="width: 100%;">
                    <mat-label>Token Delivery Method</mat-label>
                    <mat-select formControlName="tokenDelivery">
                      <mat-option *ngFor="let otpOption of otpOPtions" [value]="otpOption.name">
                        {{ otpOption.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="authenticationForm.controls.tokenDelivery.hasError('required')">
                        Select atleast 1 option
                    </mat-error>
                  </mat-form-field>
            </div>
  
            <div *ngIf="showTokenFields">
                <div style="display: grid; grid-template-columns: 3fr  1fr;">
                <mat-form-field style="width: 100%;">
                    <mat-label>OTP</mat-label>
                    <input type="text" formControlName="token" required matInput />
                    <mat-error *ngIf="authenticationForm.controls.token.hasError('required')">
                      OTP <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                  <div style="margin-left: 1rem;">
                    <button mat-fab aria-label="Refresh token" >
                      <mat-icon  matTooltip="Refresh Token" [class.rotate]="refreshingToken" (click)="handleTokenMethodConfirmation()">refresh</mat-icon>
                    </button>
                  </div>
                </div>
        
            </div>

        </div>
    </form>

</div>


<mat-dialog-actions align="center">
    <button mat-raised-button (click)="handleCancelNavigation()" >{{ showUserFields ? 'Cancel' : 'Back'}}</button>
    <button mat-raised-button color="primary" #confirmButton *ngIf="showUserFields"  (click)="handleConfirmButton()">Next</button>
    <button mat-raised-button color="primary" #confirmButton *ngIf="showTokenMethodFields" (click)="handleConfirmButton()">Get Token</button>
    <button mat-raised-button color="primary" #confirmButton *ngIf="showTokenFields" (click)="handleConfirmButton()">Approve</button>
</mat-dialog-actions>
